module.exports = __webpack_public_path__ + "img/house-img3.8a5581ce.jpg";